<template>
  <div class="wrapper">
    <alert-empty-file offset-x></alert-empty-file>
    <alert-cert-expire offset-x></alert-cert-expire>


    <!-- v-if="selectedCompanyProductList?.isApAutomateType?.isSAP" -->
    <!-- {{ selectedCompanyProductList}} -->
    <div v-if="selectedCompanyProductList?.isApAutomate && isApRoute" class="program-bar">
        <div v-if="selectedCompanyProductList?.isApAutomateType == 1" class="sap">
          <img class="tw-h-5" src="/images/icons/sap.png" alt="">
        </div>
        <div v-if="selectedCompanyProductList?.isApAutomateType == 2" class="express">
          <div class="tw-flex tw-gap-1 tw-items-center tw-justify-center">
            <img class="tw-h-5" src="/images/icons/express.png" alt="">
          </div>
        </div>
    </div>
    <div class="app-bar">
      <!-- Branch Selection Menu -->
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div class="branch" v-bind="attrs" v-on="on">
            <div class="name">
              สาขา :
              <span v-if="!selectedBranch">ทั้งหมด</span>
              <span v-if="selectedBranch">{{ selectedBranch }}</span>
            </div>
            <img src="/images/icon-angle-down.svg" alt="dropdown" />
          </div>
        </template>
        <v-list>
          <v-list-item link>
            <v-list-item-title v-on:click="setSelectedBranch('')"
              >ทั้งหมด</v-list-item-title
            >
          </v-list-item>
          <v-list-item
            link
            v-for="branch in branchList"
            :key="branch"
            v-on:click="setSelectedBranch(branch)"
          >
            <v-list-item-title>{{ branch }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <!-- Company Selection Menu -->
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div class="company-name" v-bind="attrs" v-on="on">
            <v-avatar
              size="40"
              color="#F5F5F5"
              class="mr-3 font-24 logoText"
              style="background-color: #fff"
            >
              <img
                v-if="selectedCompany.imageLogoUrl"
                :src="
                  selectedCompany.imageLogoUrl +
                  '=s' +
                  Math.round(40 * getDeviceRatio())
                "
                :alt="selectedCompany.nameTH"
                style="object-fit: contain"
              />
              <span
                v-else-if="selectedCompany.nameEN"
                class="edit-text-avatar"
                >{{ selectedCompany.nameEN[0].toUpperCase() }}</span
              >
            </v-avatar>
            <h3>{{ selectedCompany.nameTH }}</h3>
            <img
              src="/images/icon-angle-down.svg"
              alt="dropdown"
              class="change-company"
            />
          </div>
        </template>
        <v-list>
          <v-list-item
            link
            v-for="company in filteredCompanies"
            :key="company.id"
            :href="company.id === '6SyrlgRydgjKmrsCEwga'
              ? isApRouteStudent
              : `/${getCompanyId(company.id)}/dashboard`"
          >
            <v-avatar
              color="#F5F5F5"
              size="30"
              class="mr-3 logoText"
              style="background-color: #fff"
            >
              <img
                v-if="company.company.imageLogoUrl"
                :src="
                  company.company.imageLogoUrl +
                  '=s' +
                  Math.round(30 * getDeviceRatio())
                "
                :alt="company.company.nameTH"
                style="object-fit: contain"
              />
              <span
                v-else-if="company.company.nameEN"
                class="edit-text-avatar"
                >{{ company.company.nameEN[0].toUpperCase() }}</span
              >
            </v-avatar>
            <v-list-item-title>{{ company.company.nameTH }}</v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item link key="add-company" href="/company-add">
            <v-avatar size="30" class="mr-3 logoText">
              <v-icon
                dark
                left
                color="#707070"
                size="20px"
                style="margin-left: 10px"
                >mdi-plus-circle-outline</v-icon
              >
            </v-avatar>
            <v-list-item-title>สร้างบริษัทใหม่</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import AlertEmptyFile from "@/components/admin/documents/alertEmptyFile";
import AlertCertExpire from "@/components/admin/documents/alertCertExpire";

// const studentCompanyIds = [
//   "6SyrlgRydgjKmrsCEwga",
//   "HfqfyNYSNKY2JoVJitNb",
//   "eOSDsGBKjFZfDBH0AdBK",
//   "Z1gTJOuzuuJvuHWW3Ckt",
//   "HedYda0bn4TPoRar37yN",
//   "m2XXw3tgqqiHQgKa5wGy",
//   "1mC0yZM960a0EnMeKDfk",
//   "lgSH44502XPJcEdFlVGF",
//   "ZRkN2AfCYj8AETTxPrK9",
//   "skkfXYWtCWs5k63zDuS6",
//   "s68PxpcLTIUld8LE8Qna",
//   "k3Y47RAsQeE3al4WPId4",
//   "vWM7EgPgozaQQSPrDtHr",
//   "O7Rzy73u4feplqcxsbkq",
//   "QEpgXxZizPNrosBFHlYk",
//   "N7okw2LhO1bF2bobPLDi",
//   "6CgB8ryPLgL53w8gGOPK",
//   "ffTs69biO9hl3C5IEylS",
//   "w4ownadTBkksSpPLeOBw",

//   // 2nd train AJ.Authen
//   "rMJMy0xIXWyUtPfIlyhP",
//   "ubHXY3lL79FBSGSVpV4W",
//   "HPms5KOkB61lKCXsAHjb",
//   "4yLW2tTkrAI0nZbbDstr",
//   "YLx35w2ytic4KLjYOJlK",
//   "kY17MCMHmKx9o43jiZVV",
//   "eY5g9kYNqb8mLf3tdU7x",
//   "t3MKw6wvIdEK3Mp0fS8N",
//   "1nzQenjiSyuUx9Q7ovab",
//   "rPf7bZffYoxc2JJTgzkw",
//   "GiYyJIrTLaUtlmXNezyR",
//   "vlq9JFg95UQ7MJAmpAZ5",
//   "XRWCTEKs0Bw1JPTLjB3k",
//   "6tskPiUH5EoO7qMRBO0I",
//   "JLYX7ZQo1hv1FAkuWADs",
//   "HbgGRfhVR9tzIs50zviK",
//   "LeaWCSALnh7IrH0H1Qg1",
//   "Apff3BfykWfXMixKcans",
//   "gBGTzbskzyVDL12umfjk",
//   "PuwAIFXiTWOw9C7GMGHX",
//   "rp0VN8MA5qCnWun99hQt",   
//    "zWPGYOPXnczCdHfJwaj0",   
//   "WSZIrVD2Q6wSeSy47eKj",
//   "v68sS0gTbznjGh1eMW06",
//   "qIWFangYP1n2BkNFlS9m",
//   "UnGg1F3HjYLo4S5OvMcC",
//   "rkZjNABAuKyk88Z0ye5s",
//   "dB7qOY9e9yzhpKAlZSor",
//   "rmCa4RCGLmhUQugmU5Xc",
//   "KBE2PMJ8DaYlTZ4F2Mvk",
//   "wWiNZPLY1msXkoZdxZGS",
//   "HsvB5qzuuMD7ZHFO6QXG",
//   "nerex8BCTldC9pUIhzXy",
//   "rGJ01vhA9ojyphZZn71X",
//   "rXBzDZfcCAFa7E48T6ZD",
//   "7o5QGjxXv1fzGV4LaESr",
//   "OdzhpwXg8PJXo9hvDtn4",
//   "QqxgzK3EOODmjNnFuCT3",
//   "9P44cX8FmQkVYaF1TYgD",
//   "GLSDVIwBNbaixnQsRU0O",
//   "7wO0AWgMWXhrreD3El82",
//   "P3durls98oouEpKCZKlW",
//   "1xVQb7mlOzt1TnKdjSAy",
//   "UE55GHOgVVKF0ZWSoyLE",
//   "3yZAu5KmECdlSH05Crj9",
//   "sHofOremv6JOAD1U0AKB",
//   "yiMv5N6M8CPOVg4pPbiy",
//   "GQSOFmqPM1UsCiROEMK9",
//   "M8tcil6vAqc5kq7IaP8B",
//   "zjk8l2OvZNEe88QqFJtW",
//   "iT7LxTVKiqM6645jw9pP",
//   "VDKxsCaNV5Sc025jUokT",
//   "02Usy3t5lqKcYms8QZ0P",
//   "wyTnS8XLG8O0thABiYBU",
//   "skBNH8fY0Yxb1qzm28tX",
//   "VxtBn5sRDTMKkZsRI5Ia",
//   "H8G373ylxcUYY0qakmqx",
//   "OnhdWT9jD4viudIZZ6ED",
//   "YWnEaFVXuspHar3OSsvk",
//   "yxiz53lBQMe8TugScJ4E",
// ];

export default {
  name: "AppBar",
  components: {
    AlertEmptyFile,
    AlertCertExpire,
  },
  data() {
    return {
      companyVisibility: {},
    };
  },
  computed: {
    ...mapState({
      companies: (state) => state.companies.list,
      selectedCompany: (state) => state.companies.selectedCompany,
      selectedBranch: (state) => state.companies.selectedBranch,
      branchList: (state) => state.companies.branchList,
      selectedCompanyProductList: (state) =>
        state.companies.selectedCompanyProductList,
      user: (state) => state.user.userData, // Access the user state
    }),
    STORAGE_KEY() {
      return this.user?.email
        ? `companyVisibilitySettings_${this.user.email}`
        : null;
    },
    filteredCompanies() {
      // If there is no companyVisibility setting, show all companies
      if (!Object.keys(this.companyVisibility).length) return this.companies;

      // Filter companies based on the visibility setting
      return this.companies.filter(
        (company) => this.companyVisibility[company.id] !== false
      );
    },
    isApRoute() {
      return this.$route.path.includes('accountspayable');
    },
    isApRouteStudent() {
      return this.$route.path.includes('accountspayablestudent');
    },
  },
  created() {
    this.getCompanyList();
    this.getBranchList();
    this.setCompany();
    this.getCompanyStatus();
    if (this.STORAGE_KEY) {
      this.initializeVisibilitySettings();
    }
  },
  watch: {
    STORAGE_KEY(newKey) {
      if (newKey) {
        this.initializeVisibilitySettings();
      }
    },
    selectedCompany(newComp) {
      if (newComp?.id === '6SyrlgRydgjKmrsCEwga') {
        this.$router.push('/your/special/path');
      }
    },
  //   created() {
  //   // ถ้าระหว่างโหลด component ก็ redirect ทันที
  //   if (studentCompanyIds.includes(this.selectedCompany?.id)) {
  //     this.$router.push('/your/special/path');
  //   }
  // },
  },

  methods: {
    getDeviceRatio() {
      return window.devicePixelRatio;
    },
    getCompanyId(companies_user_id) {
      if (companies_user_id) {
        return companies_user_id.split("_")[0];
      }
    },
    getCompanyList() {
      this.$store.dispatch("companies/getList");
    },
    getBranchList() {
      let companyId = this.$route.params.companyId;
      if (companyId) {
        this.$store.dispatch("companies/getBranchList", { companyId });
      }
    },
    setSelectedBranch(branch) {
      this.$store.dispatch("companies/setSelectedBranch", { branch });
    },
    setCompany() {
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/setCompany", { companyId });
    },
    getCompanyStatus() {
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("statusesByCompany/getStatus", { companyId });
    },
    getURLPath() {
      let url = this.$route.path;
      let pathList = url.split("/");
      return pathList.filter((e, i) => i > 1).join("/");
    },
    initializeVisibilitySettings() {
      // Load settings from localStorage using user-specific key
      if (this.STORAGE_KEY) {
        const savedSettings = localStorage.getItem(this.STORAGE_KEY);
        if (savedSettings) {
          this.companyVisibility = JSON.parse(savedSettings);
        } else {
          // Default to showing all companies if no settings are found
          this.companyVisibility = {};
        }
      }
    },
  },
};
</script>

<style lang="css" scoped>
.wrapper {
  height: 98px;
}

.app-bar {
  background: #ffffff;
  width: 590px;
  height: 80px;
  position: absolute;
  right: 0;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  border-bottom-left-radius: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  user-select: none;
}

.branch {
  cursor: pointer;
  display: flex;
  align-items: center;
  border-right: #c4c4c4 1px solid;
  height: 60px;
  padding-right: 20px;
  margin: 20px;
}

.branch .name {
  margin-right: 10px;
}

.branch img {
  margin-left: 10px;
}

.company-name {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.company-name .change-company {
  position: absolute;
  right: 21px;
}

.company-name h3 {
  margin: 0;
}

.logoText {
  font-weight: bold;
}

.edit-text-avatar {
  margin-top: 3px;
  margin-left: -1px;
}

.font-24 {
  font-size: 24px;
}

.program-bar {
  border-radius: 0 0 18px  18px;
  text-align: center;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  width: 100px;
  height: 50px;
  position: absolute;
  overflow: clip;
  right: 620px;
}

.program-bar .sap {
  border-top: 5px solid rgb(240, 176, 0);
  color: orange;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  font-size: 1rem;
  font-weight: bolder;
}

.program-bar .express {
  border-top: 5px solid rgb(189, 0, 0);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  font-size: 1rem;
  font-weight: bolder;
}

@media screen and (max-width: 480px) {
  .wrapper .app-bar {
    width: 100vw;
  }
}
</style>
